import ScrollView from './src/main.vue';
export default ScrollView;
